import React, { useState } from "react";

const PincodeInput = ({ length, onChange }) => {
  const [values, setValues] = useState(Array(length).fill(""));

  const handleChange = (e, index) => {
    const val = e.target.value;
    if (val.length > 1) return;

    const newValues = [...values];
    newValues[index] = val;
    setValues(newValues);
    onChange(newValues.join(""));

    if (val && index < length - 1) {
      document.getElementById(`input-${index + 1}`).focus();
    }
  };

  const handleBackspace = (e, index) => {
    if (e.key === "Backspace" && !values[index] && index > 0) {
      document.getElementById(`input-${index - 1}`).focus();
    }
  };


  return (
    <div className="pincode-input">
      {values.map((val, index) => (
        <input
          key={index}
          id={`input-${index}`}
          type="password"
          maxLength="1"
          value={val}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleBackspace(e, index)}
          // autoFocus={index === 0 ? true : false}
          style={{ width: "4rem", height: "3rem", textAlign: "center", marginRight: "1.1rem" }}
          className="ant-input"
        />
      ))}
    </div>
  );
};
export default PincodeInput;
